<template>
  <!--  专题首页-->
  <div class="poor">
    <div class="poor_box">
      <el-card v-if="menuPerm('wenjuan:insert')">
        <el-form :inline="true" label-width="120px" size="small">
          <el-form-item>
            <el-button style="margin-left: 20px" type="primary" @click="add"
              >添加</el-button
            >
          </el-form-item>
        </el-form>
      </el-card>

      <el-card v-loading="loading">
        <el-table
          :data="MessageList"
          :header-cell-style="getRowClass"
          border
          ref="multipleTable"
          style="width: 100%; flex: auto"
          tooltip-effect="light"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            prop="activityName"
            label="活动名称"
            align="center"
            width="200"
            fixed
          ></el-table-column>
          <el-table-column
            prop="introduce"
            label="活动介绍"
            align="center"
            width="200"
          >
            <template slot-scope="{ row }">
              <a :title="row.introduce">{{ row.introduce }}</a>
            </template>
          </el-table-column>
          <el-table-column
            prop="pcImgUrl"
            label="封面图"
            width="200px"
            height="200px"
            align="center"
          >
            <template slot-scope="{ row }">
              <img :src="row.coverUrl" alt style="width: 100%; height: auto" />
            </template>
          </el-table-column>
          <!-- :data-clipboard-text="
                  'https://www.weiguanzixun.com/wj?userId=&id=' + row.id
                " -->
          <el-table-column label="链接" prop="linkTo" width="150px">
            <template slot-scope="{ row }">
              <el-button
                @click="copy"
                type="primary"
                size="mini"
                class="btns"
                :data-clipboard-text="
                  'https://www.weiguanzixun.com/wj?userId=&id=' + row.id
                "
                >复制</el-button
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="examineStatus"
            label="审核状态"
            align="center"
            width="200px"
          >
            <template slot-scope="{ row }">
              <el-select
                placeholder="请选择"
                v-model="row.examineStatus"
                @change="examChange($event, row)"
                v-if="menuPerm('wenjuan:review')"
              >
                <el-option
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  v-for="item in examineStatus"
                ></el-option>
              </el-select>

              <div v-if="menuPerm('wenjuan:submitReview')">
                <el-button
                  size="mini"
                  type="danger"
                  v-if="row.examineStatus == 2"
                  >未提交审核</el-button
                >
                <el-button
                  size="mini"
                  type="warning"
                  v-if="row.examineStatus == 3"
                  >审核中</el-button
                >
                <el-button
                  size="mini"
                  type="danger"
                  v-if="row.examineStatus == 4"
                  >审核未通过</el-button
                >
                <el-button
                  size="mini"
                  type="success"
                  v-if="row.examineStatus == 1"
                  >审核通过</el-button
                >
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="examineStatus"
            label="是否轮播"
            align="center"
            width="200px"
          >
            <template slot-scope="{ row }">
              <div>
                <el-button size="mini" type="danger" v-if="row.isRotation == 0"
                  >否</el-button
                >
                <el-button size="mini" type="success" v-if="row.isRotation == 1"
                  >是</el-button
                >
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="startDate"
            label="时间范围"
            align="center"
            width="200px"
          >
            <template slot-scope="{ row }">
              <div>
                <p>{{ row.startDate }}</p>
                ~
                <p>{{ row.endDate }}</p>
              </div>
            </template></el-table-column
          >
          <el-table-column
            align="center"
            class-name="small-padding fixed-width"
            label="操作"
            width="230px"
            fixed="right"
          >
            <template slot-scope="{ row }">
              <div class="done">
                <el-button
                  size="mini"
                  style="width: 90px; margin: 0 0 10px 10px"
                  type="primary"
                  @click="detail(row)"
                  v-if="menuPerm('wenjuan:list')"
                  ref="detail"
                  >题目列表</el-button
                >
                <el-button
                  size="mini"
                  style="width: 90px; margin: 0 0 10px 10px"
                  type="primary"
                  @click="changeList(row)"
                  v-if="menuPerm('wenjuan:update')"
                  :disabled="
                    (row.examineStatus == 1 || row.examineStatus == 3) &&
                    allOpen
                      ? true
                      : false
                  "
                  >修改</el-button
                >
                <el-button
                  size="mini"
                  style="width: 90px; margin: 0 0 10px 10px"
                  type="primary"
                  @click="handleExamine(row)"
                  v-if="menuPerm('wenjuan:submitReview')"
                  :disabled="
                    (row.examineStatus == 1 || row.examineStatus == 3) &&
                    allOpen
                      ? true
                      : false
                  "
                  >提交审核</el-button
                >
                <el-button
                  size="mini"
                  style="width: 90px; margin: 0 0 10px 10px"
                  type="primary"
                  @click="result(row)"
                  v-if="menuPerm('wenjuan:result')"
                  >统计结果</el-button
                ><el-button
                  size="mini"
                  style="width: 90px; margin: 0 0 10px 10px"
                  type="primary"
                  @click="participant(row)"
                  v-if="menuPerm('wenjuan:list')"
                  >参与者</el-button
                >
                <el-button
                  size="mini"
                  style="width: 90px; margin: 0 0 10px 10px"
                  type="primary"
                  @click="push(row)"
                  v-if="menuPerm('app:push')"
                  >推送</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-row style="width: auto; marginright: 50px; margintop: 20px">
          <el-pagination
            :current-page="currentPage"
            :page-size="pagesize"
            :page-sizes="[5, 10, 15]"
            :total="totalCount"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          ></el-pagination>
        </el-row>
      </el-card>
    </div>
    <!-- 详情页面 -->
    <a-drawer
      title="题目列表"
      :width="900"
      :visible="detailvisible"
      :body-style="{ paddingBottom: '80px' }"
      @close="onClose"
    >
      <Detail :Detaildata="detailData" />
    </a-drawer>
    <!-- 修改页面 -->
    <a-drawer
      title="活动详情"
      :width="900"
      :visible="changevisible"
      :body-style="{ paddingBottom: '80px' }"
      @close="onClose"
    >
      <Change :Changedata="changeData" />
    </a-drawer>
    <!-- 统计图 -->
    <a-drawer
      title="统计结果"
      :width="900"
      :visible="resultvisible"
      :body-style="{ paddingBottom: '80px' }"
      @close="onClose"
    >
      <Result :ResultData="resultData" />
    </a-drawer>
    <!-- 参与者 -->
    <a-drawer
      title="参与者"
      :width="900"
      :visible="participantvisible"
      :body-style="{ paddingBottom: '80px' }"
      @close="onClose"
    >
      <Participant :ParticipantData="participantData" />
    </a-drawer>
  </div>
</template>
<script>
import Detail from "./detail";
import Change from "./change";
import Result from "./result";
import Participant from "./participant";
import Clipboard from "clipboard";
export default {
  components: {
    Detail,
    Change,
    Result,
    Participant,
  },
  data() {
    return {
      allOpen: true,
      MessageList: [], //留言列表
      pagesize: 10, //每页的个数
      currentPage: 1, //初始页
      totalCount: 0, //分页数量展示
      detailvisible: false,
      changevisible: false,
      resultvisible: false,
      participantvisible: false,
      detailData: "",
      changeData: "",
      resultData: "",
      participantData: "",
      //查询的数据：
      searchData: {
        examineStatus: "", //审核状态
        type: "", //留言类型
        activityName: "", //活动名称
        nickName: "", //留言人昵称
      },

      //状态--下拉框：
      newsStatus: [
        // {
        //   value: "2",
        //   label: "未提交审核",
        // },
        {
          value: "3",
          label: "审核中",
        },
        {
          value: "4",
          label: "审核未通过",
        },
        {
          value: "1",
          label: "审核通过",
        },
      ],
      //留言类型--下拉框：
      messageType: [
        {
          value: 1,
          label: "新闻",
        },
        // {
        //   value: 2,
        //   label: "朋友圈",
        // },
        // {
        //   value: 3,
        //   label: "大V",
        // },
        {
          value: 4,
          label: "音频",
        },
        {
          value: 5,
          label: "视频",
        },
        {
          value: 6,
          label: "专题",
        },
      ],
      //状态--下拉框：
      examineStatus: [
        {
          value: 2,
          label: "未提交审核",
        },
        {
          value: 3,
          label: "审核中",
        },
        {
          value: 4,
          label: "审核未通过",
        },
        {
          value: 1,
          label: "审核通过",
        },
      ],
      loading: false,
    };
  },
  methods: {
    //复制文本：
    copy() {
      var that = this;
      var clipboard = new Clipboard(".btns"); //单页面引用
      // 　　　var clipboard = new this.Clipboard(".btn"); //在main.js中引用
      clipboard.on("success", (e) => {
        this.$message.success("复制成功");

        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        this.$message.error("该浏览器不支持自动复制");
        // 释放内存
        clipboard.destroy();
      });
    },
    //头部样式
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f5f7fa;color:#000;width:100%;text-aligin:center;text-align: center;";
      } else {
        return "";
      }
    },
    //问卷调查:
    getList() {
      this.postAxios("/wenjuan/list", {
        pageNum: this.currentPage,
        pageSize: 10,
      }).then((res) => {
        if (res.success == true) {
          this.MessageList = res.content;
          this.totalCount = res.totalCount;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //查询列表：
    messageSearch() {
      this.currentPage = 1;
      this.loading = true;
      this.postAxios("/wenjuan/list", {
        pageNum: this.currentPage,
        pageSize: 10,
        activityName: this.searchData.activityName,
        examineStatus: this.searchData.examineStatus, //审核状态
      }).then((res) => {
        if (res.success == true) {
          this.MessageList = res.content;
          this.totalCount = res.totalCount;
          this.loading = false;
        } else if (res.success == false) {
          this.$message.error(res.message);
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        }
      });
    },
    // 详情
    detail(row) {
      this.detailvisible = true;
      this.detailData = row;
    },
    // 修改
    changeList(row) {
      this.changevisible = true;
      this.changeData = row;
    },
    // 提交审核
    handleExamine(row) {
      this.getAxios(`wenjuan/submit/review?id=${row.id}`).then((res) => {
        if (res.success == true) {
          this.getList();
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 统计结果
    result(row) {
      this.resultvisible = true;
      this.resultData = row.id;
    },
    // 参与者
    participant(row) {
      this.participantvisible = true;
      this.participantData = row;
    },
    // app推送
    push(row) {
      this.getAxios("/app/push", {
        type: 10,
        id: row.id,
      }).then((res) => {
        if (res.success == true) {
          this.$message.success(res.message);
        } else if (res.success == false) {
          this.$message.error(res.message);
        } else if (res.success == false && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        }
      });
    },
    // 审核
    examChange(val, row) {
      this.getAxios("/wenjuan/review", {
        id: row.id,
        examineStatus: val,
      }).then((res) => {
        if (res.success) {
          this.$message.success(res.message);
          this.getList();
        } else if (res.success == false && res.statusCode == 401) {
          this.$message.error(res.message);
          this.$router.push("/");
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 添加
    add() {
      this.$router.push("/wjAdd");
    },
    onClose() {
      this.detailvisible = false;
      this.changevisible = false;
      this.resultvisible = false;
      this.participantvisible = false;
    },
    //清空查询条件：
    topicClear() {
      this.searchData = {};
    },
    //转时间
    addZero(num) {
      return num < 10 ? "0" + num : num;
    },
    //转时间
    formatDateTime(date) {
      const time = new Date(Date.parse(date));
      // time.setTime(time.setHours(time.getHours() + 8));
      const Y = time.getFullYear() + "-";
      const M = this.addZero(time.getMonth() + 1) + "-";
      const D = this.addZero(time.getDate()) + " ";
      const h = this.addZero(time.getHours()) + ":";
      const m = this.addZero(time.getMinutes()) + ":";
      const s = this.addZero(time.getSeconds());
      // const s = this.addZero(time.getSeconds());
      return Y + M + D + h + m + s;
    },
    //分页
    handleCurrentChange: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //分页：
    handleSizeChange: function (size) {
      this.pagesize = size;
      this.getList();
    },
    //分页
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
  },
  created() {
    this.getList(); //获取留言列表
  },
  mounted() {},
};
</script>
<style scoped lang="less">
.poor {
  width: 100%;
  height: 100%;
  .poor_box {
    width: 95%;
    height: auto;
    margin: 20px auto;
    .el-card {
      margin-top: 15px;
      .news_title {
        display: block;
        width: 170px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    .done {
      display: flex;
      flex-wrap: wrap;
      // flex-direction: column;
      // width: 100px;

      /deep/ .el-button--primary {
        color: #fff;
        background-color: #409eff;
        border-color: #409eff;
        width: 100px;
        margin-top: 10px;
        margin-left: 10px;
      }
    }
    /deep/ .el-button--primary {
      color: #fff;
      background-color: #409eff;
      border-color: #409eff;
      width: 100px;
    }
  }
}
a {
  color: #606266 !important;
  white-space: nowrap;
  overflow: hidden;
}
</style>